export default __webpack_public_path__ + "static/media/wave1.2fbb6516.svg";